import endpoint from '../../features/endPoints/cmsEndpoints';
import { client } from '../base/ecommClient';


const validatePostalCodeClient = (zipcode) => {
  return client.get(
    endpoint.getPostalCodeStatus(zipcode),
    '',
    mapResponse,
    mapError
  );
};


//map response to object needed by React view
const mapResponse = (response) => {
  return response;
};

//map error to object needed by React view
const mapError = (error) => {
  return error;
};

export default validatePostalCodeClient;